import React from "react";
import { CornerDownRight, FileText, Inbox } from "lucide-react";
import { Pill } from "../common/Pill";
import type { MemosMap } from "../../types";

export interface MemoPanelMatter {
  id: string;
  name: string;
}

export interface MemoPanelProps {
  memos: MemosMap;
  activeWs: string;
  setActiveWs: (id: string) => void;
  wsDefs: MemoPanelMatter[];
}

/* The "Memo" tab — selectable workstream → its confirmed-fact list, including
   value, source, and override history. */
export function MemoPanel({ memos, activeWs, setActiveWs, wsDefs }: MemoPanelProps): JSX.Element {
  const ws = activeWs === "unassoc" || !memos[activeWs] ? wsDefs[0].id : activeWs;
  const m = memos[ws] || { phase: "—", fields: {} };
  const fields = Object.entries(m.fields);
  return (
    <div>
      <div className="mhd">
        <select
          className="sel"
          value={ws}
          onChange={(e) => setActiveWs(e.target.value)}
          style={{ width: "100%" }}
        >
          {wsDefs.map((w) => (
            <option key={w.id} value={w.id}>
              {w.name}
            </option>
          ))}
        </select>
      </div>
      <div className="kv" style={{ marginBottom: 6 }}>
        <span className="k">Phase</span>
        <Pill color="--blue" label={m.phase} />
      </div>
      {fields.length === 0 && (
        <div className="empty">
          No confirmed facts yet.
          <br />
          Approve deal-memo candidates to populate.
        </div>
      )}
      {fields.map(([k, v]) => {
        const isDocSrc =
          v.source && /Charter|SPA|IRA|ROFR|Voting|cap table|Cap Table|Term Sheet/i.test(v.source);
        return (
          <div className="mfield" key={k}>
            <div className="mk">{k}</div>
            <div className="mv">{v.value}</div>
            {v.source && (
              <div className="src">
                {isDocSrc ? <FileText size={11} /> : <Inbox size={11} />}From {v.source}
              </div>
            )}
            {v.history &&
              v.history.length > 0 &&
              v.history.map((h, i) => (
                <div className="lin" key={i}>
                  <CornerDownRight size={11} />
                  overrides {h.value}
                  {h.source ? " (" + h.source + ")" : ""}
                </div>
              ))}
          </div>
        );
      })}
    </div>
  );
}
